export default "__VITE_ASSET__CQ33svra__"